import { Box, Center, Spinner } from '@chakra-ui/react';
import { useGetUserInfoSelector } from 'core/redux/selectors/authSelectors';
import { DITable } from 'plugins/DITable';
import TablePagination from 'plugins/DITable/Pagination';
import useProductTitleContainer from './ProductTitleContainer';
import DeleteProductModal from './views/DeleteProductModal';
import ProductTitleToolbar from './views/ProductTitleToolbar';
import TagSplitModal from './views/TagSplitModal';
import UpdateAndAddModal from './views/UpdateAndAdd/UpdateAndAddModel';

const ProductTitleView = () => {
    const props = useProductTitleContainer();

    const {
        tableInstance,
        isLoading,
        isFetching,
        productToUpdate,
        retailer,
        lang,
        isDeleteOpen,
        isOpen,
        modalType,
        clientProducts,
        isUpc,
        isTagOpen,
        readonly,
        OnTagClose,
        onDeleteClose,
        setProductToUpdate,
        onClose,
        onDeleteOpen,
    } = props;

    return (
        <Box>
            <ProductTitleToolbar {...props} />
            {isLoading || isFetching ? (
                <Center w="100%" h="200px" bg="white" border="1px solid" borderColor="gray.100">
                    <Spinner />
                </Center>
            ) : (
                <>
                    <DITable {...tableInstance} isPagination isHeaderFixed />
                    <TablePagination tableInstance={tableInstance} />
                </>
            )}
            <UpdateAndAddModal
                {...{
                    isOpen,
                    modalType,
                    productToUpdate,
                    retailer,
                    lang,
                    clientProducts,
                    isUpc,
                    setProductToUpdate,
                    onClose,
                    onDeleteOpen,
                    readonly,
                }}
            />
            <DeleteProductModal
                {...{
                    productToUpdate,
                    retailer,
                    lang,
                    onDeleteClose,
                    isDeleteOpen,
                }}
            />
            <TagSplitModal {...{ isTagOpen, OnTagClose, clientProducts, readonly }} />
        </Box>
    );
};

export default ProductTitleView;
